import { FormShell, Field, useFormSubmit, Success } from "@/components/forms/FormShell";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function RequestPart() {
  const { loading, done, submit } = useFormSubmit("/part-request");
  const onSubmit = (e) => {
    e.preventDefault();
    submit(Object.fromEntries(new FormData(e.target)), api);
  };
  return (
    <FormShell
      kicker="Request a part"
      title="Can't find what you need?"
      description="Give us your vehicle and part-number information and we'll research sourcing options and send you a quote."
    >
      {done ? (
        <Success message="Your part request is queued. We'll email you as soon as we have sourcing information." />
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="part-request-form">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Full name" name="name" required />
            <Field label="Email" name="email" type="email" required />
            <Field label="Phone" name="phone" />
            <Field label="Quantity" name="quantity" />
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <Field label="Year" name="year" />
            <Field label="Make" name="make" />
            <Field label="Model" name="model" />
            <Field label="Trim" name="trim" />
            <Field label="Engine" name="engine" />
            <Field label="VIN" name="vin" />
            <Field label="Product needed" name="product_needed" />
            <Field label="OEM part number" name="oem_part_number" />
            <Field label="Condition preference" name="condition_preference" placeholder="OEM / Reman / Any" />
            <Field label="Target budget" name="target_budget" />
            <Field label="Deadline" name="deadline" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Additional notes</Label>
            <Textarea data-testid="field-notes" name="notes" rows={4} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="bg-[#0055FF] hover:bg-[#0044CC] h-11 px-6" data-testid="part-request-submit">
            {loading ? "Sending…" : "Submit part request"}
          </Button>
        </form>
      )}
    </FormShell>
  );
}
